import { defineMessages } from 'react-intl'

const scope = `procurify.modules.purchasing.features.set-external-po-numbering.presenters.external-po-numbering-toggle-presenter`

export default defineMessages({
  // Angular SETTINGS_CUSTOMIZE_PO_EXTERNAL_PO_NUMBERING notification copy,
  // sentence-cased
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage:
      'Successfully updated external PO number settings preference for automatically generated POs.',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  errorMessage: {
    id: `${scope}.errorMessage`,
    defaultMessage: 'Something went wrong. Please try again later.',
  },
})
